import React from "react";

const InternalLoader = () => {
  return (
    <div>
      <div data-reactroot className="am-toast am-toast-mask">
        <span>
          <div className="am-toast-notice">
            <div className="am-toast-notice-content">
              <div
                className="am-toast-text am-toast-text-icon"
                role="alert"
                aria-live="assertive"
              >
                <svg className="am-icon am-icon-loading am-icon-lg">
                  <use xlinkHref="#loading" />
                </svg>
                <div className="am-toast-text-info">Loading</div>
              </div>
            </div>
          </div>
        </span>
      </div>
    </div>
  );
};

export default InternalLoader;
